import 'chartjs-plugin-datalabels';
import { FormatAsDollars } from '../../../utils/Helpers/Format';

const chartOptions = ({
  opts,
  rateValue,
  isLowest,
  yAxesLabel,
  savedLabel,
}) => {
  const isMobile = window.innerWidth < 768;

  return {
    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: isMobile ? 1 : 1,
    layout: {
      padding: 10,
    },
    scales: {
      y: {
        display: true,
        stacked: true,
        gridLines: {
          display: true,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        ticks: {
          callback: function (value) {
            return `$${value.toFixed(0)}`;
          },
          fontSize: 14,
          fontColor: '#000000',
          fontFamily: "Interstate, 'Open Sans'",
          padding: 15,
          maxTicksLimit: 6,
        },
        scaleLabel: {
          display: true,
          labelString: yAxesLabel,
          fontSize: 14,
          fontWeight: 800,
          fontColor: '#262626',
          fontFamily: "Interstate, 'Open Sans'",
        },
      },
      x: {
        gridLines: {
          display: false,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        stacked: true,
        barThickness: 60,
        categorySpacing: 10,
        ticks: {
          fontSize: 14,
          fontWeight: 800,
          fontColor: '#262626',
          fontFamily: "Interstate, 'Open Sans'",
        },
      },
    },
    plugins: {
      legend: {
        reverse: true,
        position: 'bottom',
        onClick: function (e) {
          e.stopPropagation();
        },
        labels: {
          fontSize: 14,
          fontColor: '#262626',
          padding: 20,
          fontFamily: "Interstate, 'Open Sans'",
          boxWidth: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += `$${context.parsed.y.toFixed(2)}`;
            }
            return label;
          },
        },
      },
      datalabels: {
        formatter: (value, ctx) => {
          if (ctx.datasetIndex !== ctx.chart.data.datasets.length - 1)
            return '';
          return ctx.dataIndex === 0
            ? isLowest
              ? `${FormatAsDollars(rateValue.toFixed(0))} ${savedLabel}`
              : ''
            : opts[ctx.dataIndex].savings && opts[ctx.dataIndex].savings > 0
            ? `${FormatAsDollars(
                opts[ctx.dataIndex].savings.toFixed(0)
              )} ${savedLabel}`
            : '';
        },
        align: 'end',
        anchor: 'end',
        color: (ctx) => {
          return '#000000';
        },
        font: {
          weight: isMobile ? 800 : 500,
          size: isMobile ? 12 : 24,
        },
      },
    },
  };
};

export default chartOptions;
